import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";

export default function MovieCard({ movie }: { movie: Movie }) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200/80 hover:border-accent-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-primary-900">
        <img
          src={movie.cover}
          alt={`${movie.title}封面`}
          title={`${movie.title} - 高清影视资源`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 via-primary-950/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
        <span className="absolute top-2 right-2 flex items-center gap-1 px-2 py-0.5 rounded-full bg-primary-950/80 text-accent-400 text-[11px] font-label">
          <i className="ri-star-fill"></i>
          {movie.rating.toFixed(1)}
        </span>
        <span className="absolute bottom-2 left-2 px-2 py-0.5 rounded bg-accent-500/95 text-primary-950 text-[11px] font-medium">
          {movie.type}
        </span>
        <span className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500 text-primary-950">
            <i className="ri-play-fill text-xl"></i>
          </span>
        </span>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
          {movie.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 truncate">
          {movie.year} · {movie.region}
        </p>
        <p className="mt-1.5 text-xs text-foreground-500 truncate">{movie.genres.join(" / ")}</p>
      </div>
    </Link>
  );
}